export const projectsTitleEN = 'Personal Projects';
export const projectsTitleES = 'Proyectos Personales';

export const projects = [
  {
    id: 1,
    title: 'Mern Stack',
    cover: '/images/personal-projects/mern-stack.jpg',
    alt: 'mern-cover',
    link: 'https://github.com/J4ASDev/mern-stack',
  },
  {
    id: 2,
    title: 'Sass Form',
    cover: '/images/personal-projects/sass-form.jpg',
    alt: 'form-sass-cover',
    link: 'https://github.com/J4ASDev/sass-form',
  },
  {
    id: 3,
    title: 'Mean Stack',
    cover: '/images/personal-projects/mean-stack.jpg',
    alt: 'mean-cover',
    link: 'https://github.com/J4ASDev/mean-stack',
  },
  {
    id: 4,
    title: 'Less Form',
    cover: '/images/personal-projects/less-form.jpg',
    alt: 'form-less-cover',
    link: 'https://github.com/J4ASDev/less-login',
  },
  {
    id: 5,
    title: 'Pets App',
    cover: './images/personal-projects/pets-app.jpg',
    alt: 'pets-app-cover',
    link: 'https://github.com/J4ASDev/pets-app'
  },
  {
    id: 6,
    title: 'Template to Emails',
    cover: '/images/personal-projects/template-to-emails.jpg',
    alt: 'template-to-emails',
    link: 'https://github.com/J4ASDev/template-to-emails',
  },
  {
    id: 7,
    title: 'Rick and Morty',
    cover: '/images/personal-projects/rick-and-morty.jpg',
    alt: 'rick-and-morty',
    link: 'https://github.com/J4ASDev/rick-and-morty-nextjs',
  },
  {
    id: 8,
    title: 'Calculator in React.js',
    cover: '/images/personal-projects/calculator-reactjs.jpg',
    alt: 'calculator-reactjs',
    link: 'https://github.com/J4ASDev/calculator-in-reactjs',
  },
  {
    id: 9,
    title: '404 Not found (Routers)',
    cover: '/images/personal-projects/404-not-found.jpg',
    alt: '404-not-found',
    link: 'https://github.com/J4ASDev/404-not-found',
  },
  {
    id: 10,
    title: 'Vanilla JS App',
    cover: '/images/personal-projects/js-vanilla-app.jpg',
    alt: 'js-vanilla-app',
    link: 'https://github.com/J4ASDev/vanilla-javascript-app',
  }
];
